export const PUSH_TO_DARWIN = 'PUSH_TO_DARWIN';
export const OPEN_IN_DARWIN = 'OPEN_IN_DARWIN';
export const OPEN_IN_DARWIN_URL = 'OPEN_IN_DARWIN_URL';
export const PUSH_TO_DARWIN_REQUEST = 'PUSH_TO_DARWIN_REQUEST';
export const PUSH_TO_DARWIN_SUCCESS = 'PUSH_TO_DARWIN_SUCCESS';
export const PUSH_TO_DARWIN_FAILURE = 'PUSH_TO_DARWIN_FAILURE';
export const PUSH_TO_DARWIN_ERROR = 'PUSH_TO_DARWIN_ERROR';
export const SET_PUSH_TO_DARWIN_STATUS = 'SET_PUSH_TO_DARWIN_STATUS';
export const NEW_DEAL_VERSION_CREATED_BY_DARWIN = 'NEW_DEAL_VERSION_CREATED_BY_DARWIN';
